import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router-dom'
import { DataSetsTable } from '../../../../components/data-sets-table'
import { useOrganizationDataSets } from '../../../../stores/organization-data-sets-store'
import type { Stores } from '../../../../util/store'

export interface OrganizationDataSetsPageProps {
    stores: Stores
}

export const OrganizationDataSetsPage = observer(
    ({ stores }: OrganizationDataSetsPageProps) => {
        const { organizationId } = useParams()
        const dataSets = useOrganizationDataSets(stores, organizationId!)

        if (!dataSets) return null

        return (
            <div data-testid="org-data-sets-page">
                <DataSetsTable
                    dataSets={dataSets}
                    rowCount={dataSets.length}
                    isLoading={stores.dataSets.isFetching}
                    showProgressBars={stores.dataSets.isUpdating}
                    isTreeTable={false}
                />
            </div>
        )
    },
)
